import Types from './Types';

const INITIAL_STATE = {
    subjectAssistPhones: [],
    subjectAssistPhone: {},
    isLoading: false,
    count: ''
};

export default function subjectAssistPhones(state = INITIAL_STATE, action) {
    const { type, payload } = action;
    switch (type) {
        case Types.GET_SUBJECT_ASSIST_PHONES_SUCCESS: {
            // Handle both cases: payload.data (wrapped) or payload (direct array)
            const phonesData = Array.isArray(payload.data) ? payload.data : (Array.isArray(payload) ? payload : []);
            return {
                ...state,
                subjectAssistPhones: phonesData,
                count: phonesData.length
            };
        }

        case Types.EDIT_SUBJECT_ASSIST_PHONE_SUCCESS: {
            let data = payload.data;
            if (!data || !data.id) {
                return state; // Invalid data, return current state
            }
            const subjectAssistPhones = [...state.subjectAssistPhones];
            let idx = -1;
            subjectAssistPhones.forEach((item, index) => {
                if (item.id === data.id) {
                    idx = index;
                    return;
                }
            });

            if (idx >= 0) {
                subjectAssistPhones[idx] = data;
            }
            return {
                ...state,
                subjectAssistPhones: subjectAssistPhones
            };
        }

        // create
        case Types.CREATE_SUBJECT_ASSIST_PHONE_SUCCESS: {
            const data = payload.data.data || payload.data;
            let newArray = state.subjectAssistPhones.slice();
            newArray.push(data);
            return {
                ...state,
                subjectAssistPhones: newArray
            };
        }
        case Types.ADD_SUBJECT_ASSIST_PHONES_LOADING: {
            return {
                ...state,
                isLoading: payload
            };
        }

        case Types.DELETE_SUBJECT_ASSIST_PHONE_SUCCESS: {
            const newPhones = state.subjectAssistPhones.filter((item) => item.id !== payload);
            return {
                ...state,
                subjectAssistPhones: newPhones
            };
        }

        default: {
            return state;
        }
    }
}

